import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { saveComment /*, saveTopicComment*/ } from "Thunks";
import styles from "./Comment.local.scss";
//import Button from "Common/Button/Button";
import classnames from "classnames";
import { getUserNameForAvatar } from "Utils";
import { TTP_API_URL } from "Config";
import _ from "i18n";

class CommentPost extends PureComponent {
  areaRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = { comment: null };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.comments.saved === true) {
        this.areaRef.current.value = "";
        const node = document.querySelector("#comments_entities");
        node.scrollTop = node.scrollHeight;
      }
    }
  }

  handleChange(e) {
    this.setState({ comment: e.target.value });
  }

  handleSaveComment(e) {
    if (e.keyCode === 13) {
      const commentInput = document.getElementById("comment_input").classList;
      commentInput.add("loading");
      e.preventDefault();
      //e.stopPropagation();
      if (!this.areaRef.current.value.trim()) {
        return;
      }

      const {
        currentResource,
        saveComment,
        //saveTopicComment,
        type
      } = this.props;

      /*(type === "TOPIC"
        ? saveTopicComment({
            comment: this.areaRef.current.value,
            id: currentResource.id
          })
        : */
      saveComment({
        objectType: type,
        objectId: currentResource.id,
        comment: this.areaRef.current.value
      }).then(res => {
        commentInput.remove("loading");
      });
    }
  }

  renderAuthorAvatar(author) {
    const { id, firstName, lastName, avatar, avatarUrl } = author;

    return avatarUrl || avatar ? (
      <div
        key={`av-${id}`}
        className={styles.authorAvatar}
        style={{
          backgroundImage: `url(${
            avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
          })`
        }}
      />
    ) : (
      <div className={classnames(styles.authorAvatar, "empty-avatar")}>
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
      </div>
    );
  }

  render() {
    const { auth } = this.props;
    if (auth.loggedAs && auth.loggedAs === "GUEST") {
      return null;
    }
    return (
      <div className={styles.comment__container}>
        <div className={styles.comment__message_zone} id="comment_input">
          <textarea
            ref={this.areaRef}
            className={styles.comment__container_input}
            placeholder={_("You comment here...")}
            onChange={this.handleChange.bind(this)}
            onKeyDown={this.handleSaveComment.bind(this)}
          />
          {this.renderAuthorAvatar(auth.user)}
          {/*<Button
            className={styles.comment__container_btn}
            onClick={this.handleSaveComment.bind(this)}
          >
            <i className="icon icon-action-redo" />
          </Button>*/}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  comments: state.comments
  //topicComments: state.topicViewer.comments
});

const mapDispatchToProps = dispatch => ({
  saveComment: comment => dispatch(saveComment(comment))
  //saveTopicComment: comment => dispatch(saveTopicComment(comment))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentPost);



// WEBPACK FOOTER //
// ./src/components/Reveal/Comments/CommentPost.js